import { render, staticRenderFns } from "./requested-products.modal.vue?vue&type=template&id=934c87c8&scoped=true"
import script from "./requested-products.modal.vue?vue&type=script&lang=js"
export * from "./requested-products.modal.vue?vue&type=script&lang=js"
import style0 from "./requested-products.modal.vue?vue&type=style&index=0&id=934c87c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934c87c8",
  null
  
)

export default component.exports